exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".email-info[data-v-5adf331f] {\n  min-height: 115px;\n  height: auto;\n}\niframe[data-v-5adf331f] {\n  border: none;\n}\na[data-v-5adf331f] {\n  text-decoration: underline;\n  -webkit-text-decoration-color: #080808;\n          text-decoration-color: #080808;\n}\n.send-button-container[data-v-5adf331f] {\n  padding-top: 2.5px;\n  padding-bottom: 2.5px;\n}", ""]);

// exports
